const moment = require("moment");
import { IsToday } from "source/app/services/Time/Time";
import { ILogEntry } from "../../../../../../motw_core/Entity/ILogEntry";
import { GetAllGoalNames } from "./LogInputForm/LogInputFormHelpers";


export function GetTodaysLogEntries(logEntries: ILogEntry[]) {
    if (logEntries.length === 0) {
        return [];
    }

    const allGoalNames = GetAllGoalNames();

    if (allGoalNames.length === 0) {
        return [];
    }

    const todaysLogEntries = logEntries
        .filter((entryRow) => IsToday(moment(entryRow.lastmodifiedtime).local().format())
        )
        .map((entryRow: ILogEntry) => entryRow.entry);

    return todaysLogEntries;
}
